import { Injectable } from '@angular/core';
import { PermissionService } from './permission.service';
import { Router } from '@angular/router';
import { SessionService } from './session.service';
import { Actions } from '../backend/auth/Action';
import { Features } from '../backend/auth/Feature';
import { LandingPage } from '../backend/clients/model/landingPage';

@Injectable({
  providedIn: 'root',
})

export class LoginNavigationService {
  constructor(
    private router: Router,
    private permissionService: PermissionService,
    private sessionService: SessionService
  ) {}

  public async resolveLandingPage() : Promise<string> {
    const landingPage = this.sessionService.getUserDetails().landingPage;
    const hasDashboardAccess = await this.hasDashboardAccess();
    const hasWarrantyViewAccess = await this.hasWarrantyViewAccess();
    if(landingPage == LandingPage.Dashboard && hasDashboardAccess)
    {
      return this.sessionService.menu ?? 'dashboard';
    }
    else if (landingPage == LandingPage.WarrantyList && hasWarrantyViewAccess) {
      return this.sessionService.menu ?? 'warranties';
    }
    else if (landingPage == LandingPage.ActivateWarranty) {
      const companyData = await this.sessionService.getCompanyData();
      const hasSalesAccess = await this.hasSaleAccess();
      const hasWarrantyActivateAccess = await this.hasWarrantyActivationAccess();

      if(companyData.implicitSaleCreation && hasSalesAccess) { 
        return this.sessionService.menu ?? 'sales/add';
      }
      else if (!companyData.implicitSaleCreation && hasWarrantyActivateAccess) {
        return this.sessionService.menu ?? 'warranties/activate';
      }
      else {
        return this.sessionService.menu ?? 'your-account';
      }
    }
    else
    {
      return this.sessionService.menu ?? 'your-account';
    }
  }

  public async navigateLandingPage(path: string) : Promise<void> {
    this.router.navigate([path]);
  }

  private async hasDashboardAccess(): Promise<boolean> {
    return (await this.permissionService.hasActionPermissions(Actions.view_dashboards))
    && (await this.permissionService.hasFeaturePermissions(Features.Dashboards));
  }
  
  private async hasWarrantyActivationAccess(): Promise<boolean> {
    return (await this.permissionService.hasActionPermissions(Actions.activate_warranties))
    && (await this.permissionService.hasFeaturePermissions(Features.Warranties));
  }

  private async hasWarrantyViewAccess(): Promise<boolean> {
    return (await this.permissionService.hasActionPermissions(Actions.view_warranties))
    && (await this.permissionService.hasFeaturePermissions(Features.Warranties));
  }
  
  
  private async hasSaleAccess(): Promise<boolean> {
    return (await this.permissionService.hasActionPermissions(Actions.create_sales))
    && (await this.permissionService.hasFeaturePermissions(Features.Sales));
  }
}
